<b>{{ value | date:'yyyy/MM/dd HH:mm' }}</b>